module.exports = __webpack_public_path__ + "img/avanto.4e130100.jpeg";